<template>
  <!--div id="olMapDiv" :style="{'left': left, 'top': top}" style="z-index:0;position:fixed;right:0;bottom:0;border: 1px solid #ccc"></div-->
  <div
    fill-height
    id="olMapDiv"
    :style="{'left': left, 'top': top}"
    style="z-index:0;right:0;bottom:0;border: 1px solid #ccc; height:100%; width:100%;"
  >
    <div ref="popupContainer" class="ol-popup">
      <a href="#" @click.prevent="closePopUp" class="ol-popup-closer"></a>
      <div v-if="selectedOtherMarker">
        <p>
          {{ selectedOtherMarker.device_name || selectedOtherMarker.device_token }}
          <br />
          {{selectedOtherMarker.address}}
        </p>
        <p v-if="selectedOtherMarker.comments">{{selectedOtherMarker.comments}}</p>
        <v-row>
          <v-col xs="6">
            <v-btn @click="$router.push('/log/' + selectedOtherMarker.id)">View Chart</v-btn>
          </v-col>
          <v-col xs="6">
            <v-btn @click="$router.push('/deviceinfo/' + selectedOtherMarker.id)">View Details</v-btn>
          </v-col>
        </v-row>
      </div>
    </div>

    <v-snackbar
      class="mt-4"
      v-model="activePointMoved"
      color="primary"
      :absolute="true"
      top
      :timeout="0"
    >
      The log location has been changed.
      <v-btn color="secondary" @click="activeLocationSaved">Save</v-btn>
      <v-btn color="secondary" @click="undoActiveMarkerMoved">Undo</v-btn>
    </v-snackbar>

    <m-errorbox ref="errorBox"></m-errorbox>

  </div>
</template>


<script>
// mp035 require open layers
import "ol/ol.css";
import Map from "ol/Map.js";
import View from "ol/View.js";
import { Draw, Modify, Snap, Select, Translate } from "ol/interaction.js";
import { Tile as TileLayer, Vector as VectorLayer } from "ol/layer.js";
import { OSM, XYZ, Vector as VectorSource } from "ol/source.js";
import {
  Circle as CircleStyle,
  Fill,
  Stroke,
  Style,
  Text,
  Icon
} from "ol/style.js";
//import KML from 'ol/format/KML.js';  // now unused, was used for loading local kml from files stored on server.
import Polygon from "ol/geom/Polygon";
import Point from "ol/geom/Point";
import Feature from "ol/Feature";
import Overlay from "ol/Overlay.js";
import Collection from "ol/Collection";
import { getDistance } from "ol/sphere";
import { transform, toLonLat } from "ol/proj";
import { defaults as defaultControls, Control } from "ol/control";
import { click, pointerMove, altKeyOnly } from "ol/events/condition";
import TileState from "ol/TileState";

// bring in api details from our app
import apiEndpoints from "../mixins/api-endpoints";
import apiRequest from "../mixins/api-request";
import geoFunctions from "../mixins/geo-functions"
import formatDate from "../mixins/format-date";

function createText(content, offsetX, offsetY) {
  return new Text({
    //textAlign: undefined,
    //textBaseline: undefined,
    font: "12px sans-serif",
    text: content,
    fill: new Fill({ color: "black" }),
    stroke: new Stroke({ color: "black", width: 0.5 }),
    offsetX: offsetX,
    offsetY: offsetY,
    placement: "point"
    //maxAngle: maxAngle,
    //overflow: overflow,
    //rotation: rotation
  });
}

function createMarkerStyle(iconSrc) {
  return new Style({
    image: new Icon(
      /** @type {module:ol/style/Icon~Options} */ ({
        //anchor: [0.5, 46],
        anchor: [0.5, 0.5],
        anchorOrigin: "bottom-left",
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        src: iconSrc
      })
    )
  });
}

var markerStyleCurrent = createMarkerStyle("/img/spider-circle-72.svg");
var markerStyleOther = createMarkerStyle("/img/spider-circle-secondary-72.svg");

function createMarker(location, style) {
  var iconFeature = new Feature({
    geometry: new Point(location)
  });

  iconFeature.setStyle(style);

  return iconFeature;
}

function createPointDragInteraction(pointFeature) {
  let translate = new Translate({
    features: new Collection([pointFeature])
  });
  return translate;
}

export default {
  mixins: [apiEndpoints, apiRequest, formatDate, geoFunctions],
  props: {
    top: String,
    left: String,
    interactionType: String, // the current interaction type for the map.
    interactionSnap: {
      type: Boolean,
      default: false
    },
    activeLocation:Object,
    otherLocations:Array,
  },
  data() {
    return {
      activeMarkerFeature: null,
      lastViewVersion: null,
      tileLayers: [], // the different tile layers for the map (satelite, road etc.)
      hereLayers: [], // the different HERE layers for the map (satelite, road etc.)
      updatedCoordinates: { latitude: null, longitude: null },
      olSource: null,
      olActiveSource: null,
      olVectorLayer: null,
      olActiveVectorLayer: null,
      olMap: null,
      popUpOverlay: null,
      popUpOverlayCoordinates: undefined,
      selectedOtherMarker: null,
      defaultMapCenter: transform([133.7751, -25.2744], "EPSG:4326", "EPSG:3857"), // default to Australia
      defaultMapZoom: 4, //default to the size of Australia
    };
  },
  mounted() {
    this.setupOlMap();
    this.zoomToFitSource(false);
  },

  methods: {
    showError(err) {
      this.$refs.errorBox.showError(err);
    },
    addOtherMarkersToSource: function(otherLocations) {
      // clear old log locations if they exist
      this.olSource.clear();

      if (otherLocations) {
        otherLocations.forEach(otherLocation => {
          let location = transform(
            [otherLocation.longitude, otherLocation.latitude],
            "EPSG:4326",
            "EPSG:3857"
          );
          var feature = createMarker(location, markerStyleOther);
          feature.setId(otherLocation.id);
          this.olSource.addFeature(feature);
        });
      }
    },

    createActiveMarker: function(location) {
      if ((! location.latitude) || (! location.longitude)) return;

      location = transform(
        [location.longitude, location.latitude],
        "EPSG:4326",
        "EPSG:3857"
      );
      if (!this.activeMarkerFeature) {
        this.activeMarkerFeature = createMarker(location, markerStyleCurrent);
        this.olActiveSource.addFeature(this.activeMarkerFeature);
        this.activeMarkerTranslate = createPointDragInteraction(
          this.activeMarkerFeature
        );
        this.olMap.addInteraction(this.activeMarkerTranslate);
        this.activeMarkerTranslate.on("translateend", e => {
          console.log("CHANGED!!!!");
          let coords = e.features
            .getArray()[0]
            .getGeometry()
            .clone()
            .transform("EPSG:3857", "EPSG:4326")
            .getCoordinates();
          this.updatedCoordinates = {
            longitude: coords[0],
            latitude: coords[1]
          };
          this.$emit(
            "activeMarkerMoved",
            e.features
              .getArray()[0]
              .getGeometry()
              .clone()
              .transform("EPSG:3857", "EPSG:4326")
              .getCoordinates()
          );
        });
      } else {
        this.activeMarkerFeature.getGeometry().setCoordinates(location);
      }
      this.$emit(
        "activeMarkerMoved",
        this.activeMarkerFeature
          .getGeometry()
          .clone()
          .transform("EPSG:3857", "EPSG:4326")
          .getCoordinates()
      );
    },


    removeActiveMarker: function() {
      this.olMap.removeInteraction(this.activeMarkerTranslate);
      this.olActiveSource.removeFeature(this.activeMarkerFeature);
      this.activeMarkerFeature = null;
    },

    zoomToFitSource(animate = true) {
      // zoom to fit map
      if (this.olActiveSource.getFeatures().length < 1) {
        // no data, so nothing to zoom to, in that case set the center and zoom to land on Australia
        this.olMap.getView().setCenter(this.defaultMapCenter);
        this.olMap.getView().setZoom(this.defaultMapZoom);
        return;
      }

      var extent = this.olActiveSource.getExtent();
      //var extent = this.activeMarkerFeature.getGeometry();

      var options = {
        size: this.olMap.getSize(),
        maxZoom: 18
      };

      if (animate) {
        options.duration = 1000;
      }

      this.olMap.getView().fit(extent, options);
    },

    createUrl(tpl, layerDesc) {
      return tpl
        .replace("{style}", layerDesc.style)
        .replace("{apiKey}", layerDesc.apiKey)
        .replace("{app_id}", layerDesc.app_id)
        .replace("{app_code}", layerDesc.app_code);
    },


    arrayBufferToBase64(buffer) {
      var binary = "";
      var bytes = [].slice.call(new Uint8Array(buffer));

      bytes.forEach(b => (binary += String.fromCharCode(b)));

      return window.btoa(binary);
    },


    createHereMapsLayers() {
      this.hereLayers = [
        {
          title: "Normal",
          style: "lite.day",
        },
        {
          title: "Logistics",
          style: "logistics.day",
        },
        {
          title: "Terrain",
          style: "topo.day",
        },
        {
          title: "Satellite",
          style: "satellite.day",
        },
        {
          title: "Hybrid",
          style: "lite.satellite.day",
        }
      ];


      //let urlTpl =
      //  "https://{1-4}.{base}.maps.ls.hereapi.com" +
      //  "/{type}/2.1/maptile/newest/{scheme}/{z}/{x}/{y}/256/png";
      
      // see https://stackoverflow.com/questions/79310028/openlayers-and-here-maps-with-recent-api-keyw-no-longer-working

      let urlTpl = "https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/png?style={style}&size=512";

      this.tileLayers = [];
      var i, ii;
      for (i = 0, ii = this.hereLayers.length; i < ii; ++i) {
        var layerDesc = this.hereLayers[i];
        this.tileLayers.push(
          new TileLayer({
            visible: false,
            preload: Infinity,
            source: new XYZ({
              tileSize: [512, 512],
              url: this.createUrl(urlTpl, layerDesc),

              tileLoadFunction: (imageTile, src) => {
                if (imageTile.getTileCoord()[0] > 20){
                  // here maps tiles do not support zoom levels greater than 20,
                  // so go straight to error state without fetching.
                  imageTile.setState(TileState.ERROR);
                  return;
                }

                this.getMapToken().then(token => {

                  let headers = { Authorization: "Bearer " + token };

                  var options = {
                    method: "GET",
                    headers: headers
                  };

                  return fetch(src, options)
                    .then(r => r.arrayBuffer())
                    .then(binaryBody => {
                      var data =
                        "data:image/png;base64," +
                        this.arrayBufferToBase64(binaryBody);
                      imageTile.getImage().src = data;
                    })
                    .catch(ex => {
                      console.error(
                        "Exception in promise of map tile fetch stage:"
                      );
                      console.error(ex);
                      // set the tile state to error:
                      imageTile.setState(TileState.ERROR);
                    });
                });
              }
            })
          })
        );
      }
    },


    onMarkerSelect(e) {
      console.log("Marker Select!!!!");

      if (e.target.getFeatures().getLength() == 1) {
        let featureId = e.target
          .getFeatures()
          .item(0)
          .getId();
        this.selectedOtherMarker = this.otherLocations.find(
          val => val.id === featureId
        );

        this.popUpOverlayCoordinates = e.target
          .getFeatures()
          .item(0)
          .getGeometry()
          .getCoordinates();
      } else {
        this.selectedOtherMarker = null;
        this.popUpOverlayCoordinates = undefined;
      }
    },


    closePopUp(evt) {
      this.olSelectInteraction.getFeatures().clear();
      this.popUpOverlayCoordinates = undefined;
      if(evt){
        evt.target.blur();
      }
    },


    setupOlMap() {
      // if the map does not exist, then
      // create it (otherwise this function just renders the markers)
      if (!this.olMap) {
        this.createHereMapsLayers();

        /* removed OSM layers in favour of HERE Maps (above)
                var raster = new TileLayer({
                    source: new OSM(),
                });
                this.tileLayers.push(raster);
                */

        // the vector source for the active log
        this.olActiveSource = new VectorSource();
        this.olActiveVectorLayer = new VectorLayer({
          source: this.olActiveSource
        });

        // the vector source for other logs
        this.olSource = new VectorSource();
        this.olVectorLayer = new VectorLayer({
          source: this.olSource
        });

        // create a layer select control

        //Create array of options to be added
        var layerOptions = [
          ["normal.day", "Normal"],
          ["normal.day.transit", "Transit"],
          ["pedestrian.day", "Pedestrian"],
          ["terrain.day", "Terrain"],
          ["satellite.day", "Satellite"],
          ["hybrid.day", "Hybrid"]
        ];

        //Create and append select list
        var selectList = document.createElement("select");
        selectList.id = "mySelect";

        //Create and append the options
        for (var i = 0; i < this.hereLayers.length; i++) {
          var option = document.createElement("option");
          option.value = this.hereLayers[i].style;
          option.text = this.hereLayers[i].title;
          selectList.appendChild(option);
        }

        var element = document.createElement("div");
        element.className = "ol-layer-select ol-unselectable ol-control";
        element.appendChild(selectList);

        var onStyleSelectChange = () => {
          var style = selectList.value;
          this.setStyle(style);
        };
        selectList.addEventListener("change", onStyleSelectChange);

        var layerSelectControl = new Control({
          element: element
        });

        /**
         * Create an overlay to anchor the popup to the map.
         */
        this.popUpOverlay = new Overlay({
          element: this.$refs.popupContainer,
          autoPan: true,
          autoPanAnimation: {
            duration: 250
          }
        });

        this.olMap = new Map({
          layers: [
            ...this.tileLayers,
            this.olVectorLayer,
            this.olActiveVectorLayer
          ],
          controls: defaultControls().extend([layerSelectControl]),
          target: "olMapDiv",
          view: new View({
            //center: [-11000000, 4600000],
            center: this.defaultMapCenter,
            zoom: this.defaultMapZoom,
          }),
          overlays: [this.popUpOverlay]
        });

        /**
         * DEBUG: Add a click handler to the map to render the popup.
         */
        /*
                this.olMap.on('singleclick', (evt) => {
                    var coordinate = evt.coordinate;
                    console.log(coordinate);
                    //var hdms = toStringHDMS(toLonLat(coordinate));
                    var hdms = toLonLat(coordinate);

                    this.$refs.popupContent.innerHTML = '<p>You clicked here:</p><code>' + hdms +
                        '</code>';
                    this.popUpOverlay.setPosition(coordinate);
                });
                */

        // setp the interaction for selecting of
        // other logs only once.  It never needs adjusting
        // because it filters by layer
        this.olSelectInteraction = new Select({
          layers: [this.olVectorLayer],
          style: markerStyleOther,
          condition: click
        });
        this.olSelectInteraction.on("select", this.onMarkerSelect);
        this.olMap.addInteraction(this.olSelectInteraction);

        // set the initial map scheme
        onStyleSelectChange();
      }

      // render the active log if the coordinates are set
      // and immediately center the view over
      if (this.activeLocation) {
        this.createActiveMarker(this.activeLocation);
      }

      if (this.otherLocations) {
        this.addOtherMarkersToSource(this.otherLocations);
      }
    },


    setStyle(style) {
      for (var i = 0; i < this.hereLayers.length; ++i) {
        this.tileLayers[i].setVisible(this.hereLayers[i].style === style);
      }
    },


    undoActiveMarkerMoved(evt) {
      this.updatedCoordinates = { latitude: null, longitude: null };
      this.createActiveMarker(this.activeLocation);
      this.zoomToFitSource();
    },


    activeLocationSaved(evt) {
      this.$emit("saveActiveLocation", this.updatedCoordinates);
    }


  },
  computed: {
    activePointMoved() {
      return (
        (this.updatedCoordinates.longitude !== null ||
          this.updatedCoordinates.latitude !== null) &&
        (this.updatedCoordinates.longitude !==
          this.activeLocation.longitude ||
          this.updatedCoordinates.latitude !== this.activeLocation.latitude)
      );
    },
  },
  watch: {
    otherLocations: {
      handler: function(newVal /*oldval does not work on deep watches*/) {
        this.addOtherMarkersToSource(newVal);
      },
      deep: true
    },
    viewVersion() {
      this.zoomToFitSource();
    },
    activeLocation: function(newVal, oldVal) {
      this.updatedCoordinates = { latitude: null, longitude: null };
      // hide the popup when active location changes
      this.closePopUp();
      if (newVal && newVal.latitude && newVal.longitude) {
        this.createActiveMarker(newVal);
        this.zoomToFitSource();
      } else if (this.activeMarkerFeature){
        this.removeActiveMarker();
      }
    },
    popUpOverlayCoordinates(newVal) {
      this.popUpOverlay.setPosition(newVal);
    }
  }
};
</script>

<style>
/* css for the tile layer select control */
.ol-layer-select {
  top: 0.5em;
  left: 3em;
}
.ol-layer-select > select {
  padding-left: 10px;
  background-color: rgba(0, 60, 136, 0.5);
  color: white;
}
.ol-touch .ol-layer-select {
  /*top: 80px;*/

  /*move control away from the zoom controls for easier tapping on touch screens*/
  left: 6em;
}

/* css for the popup bubble */
.ol-popup {
  position: absolute;
  background-color: white;
  -webkit-filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));
  filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));
  padding: 15px;
  border-radius: 10px;
  border: 1px solid #cccccc;
  bottom: 12px;
  left: -50px;
  min-width: 330px;
}
.ol-popup:after,
.ol-popup:before {
  top: 100%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.ol-popup:after {
  border-top-color: white;
  border-width: 10px;
  left: 48px;
  margin-left: -10px;
}
.ol-popup:before {
  border-top-color: #cccccc;
  border-width: 11px;
  left: 48px;
  margin-left: -11px;
}
.ol-popup-closer {
  text-decoration: none;
  position: absolute;
  top: 2px;
  right: 8px;
}
.ol-popup-closer:after {
  content: "✖";
}
</style>

